const GSI_SRC = 'https://accounts.google.com/gsi/client';

let gsiLoadPromise = null;

export function loadGoogleGsi() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Tarayıcı ortamı gerekli'));
  }
  if (window.google?.accounts?.id) {
    return Promise.resolve(window.google);
  }
  if (gsiLoadPromise) {
    return gsiLoadPromise;
  }
  gsiLoadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${GSI_SRC}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve(window.google));
      existing.addEventListener('error', () => reject(new Error('Google script yüklenemedi')));
      return;
    }
    const script = document.createElement('script');
    script.src = GSI_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.google);
    script.onerror = () => reject(new Error('Google script yüklenemedi'));
    document.head.appendChild(script);
  });
  return gsiLoadPromise;
}

/**
 * Özel buton için Google id_token (credential JWT) döndürür.
 */
export async function requestGoogleIdToken(clientId) {
  if (!clientId) {
    throw new Error('Google OAuth yapılandırılmamış');
  }
  const google = await loadGoogleGsi();
  return new Promise((resolve, reject) => {
    let settled = false;
    const finish = (token, err) => {
      if (settled) return;
      settled = true;
      if (err) reject(err);
      else resolve(token);
    };

    google.accounts.id.initialize({
      client_id: clientId,
      callback: (response) => {
        if (response?.credential) {
          finish(response.credential, null);
        } else {
          finish(null, new Error('Google oturumu alınamadı'));
        }
      },
      auto_select: false,
      cancel_on_tap_outside: true,
      itp_support: true,
    });

    google.accounts.id.prompt((notification) => {
      if (settled) return;
      if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
        finish(null, new Error('Google oturumu açılamadı. Lütfen tekrar deneyin veya popup engelini kaldırın.'));
      }
    });
  });
}

export async function postGoogleIdToken(url, idToken, csrfToken) {
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
    body: JSON.stringify({ id_token: idToken }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    const msg = data.message || 'Google işlemi başarısız';
    const err = new Error(msg);
    err.code = data.code;
    err.registerUrl = data.register_url;
    throw err;
  }
  return data;
}
